export const fetchWrapper = (url, {body, ...customConfig} = {}) => {
  const headers = {'Content-Type': 'application/json'};

  const config = {
      method: body ? 'POST' : 'GET',
      ...customConfig,
      headers: {
          ...headers,
          ...customConfig.headers,
      },
  };

  if (body) {
      config.body = JSON.stringify(body)
  }

  return window
      .fetch(url, config)
      .then(async response => {
          const data = await response.json();
          if (response.ok) {
              return data;
          } else {
              return Promise.reject(data)
          }
      })
};

export const calcPercent = (partialValue, totalValue) =>
  (100 * partialValue) / totalValue;